import { searchBoxStyles } from "@insite/content-library/Widgets/MyLists/MyListsSearchBox";
import getColor from "@insite/mobius/utilities/getColor";
import Search from "@waytek/MobiusOverrides/Icons/Search";
import { colorStrings } from "@waytek/Utilities/variables";
import { css } from "styled-components";

searchBoxStyles.search = {
    ...searchBoxStyles.search,

    mergeCss: true,
    iconProps: {
        src: Search,
        color: colorStrings.commonGlobalWhite,

        css: css`
            &&& {
                background-color: ${getColor(colorStrings.secondaryMain)};
                border-radius: 0;
                padding: 10px;
                top: 0;
                right: 0;
                width: 40px;
                height: 40px;

                svg {
                    width: 18px;
                    height: 18px;
                }
            }
        `,
    },
};
